import image0 from '../../images/logistics-0.png'
import image1 from '../../images/logistics-1.png'
import image2 from '../../images/logistics-2.png'
import image3 from '../../images/logistics-3.png'
import image4 from '../../images/logistics-4.png'
import image5 from '../../images/logistics-5.png'
import image6 from '../../images/logistics-6.png'
import image7 from '../../images/logistics-7.png'
import image8 from '../../images/logistics-8.png'
import image9 from '../../images/logistics-9.png'
import image10 from '../../images/logistics-10.png'
import image11 from '../../images/logistics-11.png'
import image12 from '../../images/logistics-12.png'
import image13 from '../../images/logistics-13.png'
import image14 from '../../images/logistics-14.png'
import image28 from '../../images/logistics-15.png'
import image29 from '../../images/logistics-16.png'
import image30 from '../../images/logistics-17.png'
import image31 from '../../images/logistics-18.png'
import image15 from '../../images/spent-1.png'
import image16 from '../../images/spent-2.png'
import image17 from '../../images/spent-3.png'
import image18 from '../../images/spent-4.png'
import image19 from '../../images/spent-5.png'
import image20 from '../../images/spent-6.png'
import image21 from '../../images/spent-7.png'
import image22 from '../../images/spent-8.png'
import image23 from '../../images/spent-9.png'
import image24 from '../../images/spent-10.png'
import image25 from '../../images/spent-11.png'
import image26 from '../../images/spent-12.png'
import image27 from '../../images/spent-13.png'

export const cardImageAndBackgroundData = [
    // Logistics
    { name: 'Bulk carrier', backgroundColor: '#E2EBF4', image: image0 },
    { name: 'Chemical tanker', backgroundColor: '#CDE2F3', image: image1 },
    { name: 'General cargo ship', backgroundColor: '#D2E4EC', image: image2 },
    { name: 'Liquefied gas tanker', backgroundColor: '#CFDFF2', image: image3 },
    { name: 'Oil tanker', backgroundColor: '#CDE2F3', image: image4 },
    { name: 'Other Liquids tanker', backgroundColor: '#CDE2F3', image: image5 },
    { name: 'Refrigerated bulk carrier', backgroundColor: '#E2EBF4', image: image6 },
    { name: 'Ro-Pax', backgroundColor: '#DDE9F9', image: image7 },
    { name: 'Ro-Ro', backgroundColor: '#DDE9F9', image: image8 },
    { name: 'Vehicle carrier', backgroundColor: '#DDEFF6', image: image9 },
    {
        name: 'Inland Waterways, Container vessels',
        backgroundColor: '#CDD8E2',
        image: image10,
    },
    {
        name: 'Inland Waterways, Motor vessels',
        backgroundColor: '#D0DED7',
        image: image11,
    },
    {
        name: 'Inland Waterways, Pushed convoy',
        backgroundColor: '#F4E8D7',
        image: image12,
    },
    {
        name: 'Inland Waterways, Tanker vessels',
        backgroundColor: '#EBE6D7',
        image: image13,
    },
    { name: 'Logistics site', backgroundColor: '#E1F1F8', image: image14 },

    // truck
    { name: ['truck'], backgroundColor: '#FDE2D6', image: image28 },
    // cargo plane, passenger plane
    { name: ['plane', 'jet', 'air'], backgroundColor: '#DFE2EA', image: image29 },
    // container ship, IMO, vessel
    {
        name: ['container', 'vessel', 'IMO'],
        backgroundColor: '#DFEAFF',
        image: image31,
    },
    {
        name: 'heavy fuel oil',
        backgroundColor: '#DFEAFF',
        image: image31,
    },
    // trains
    { name: 'train', backgroundColor: '#DCF1E1', image: image30 },

    // SPENT - name represents a category
    { name: 'Cropping system', backgroundColor: '#F9E7D7', image: image15 },
    { name: 'Construction work', backgroundColor: '#F7E5D2', image: image16 },
    { name: 'Air transport', backgroundColor: '#D9E0FB', image: image17 },
    {
        name: 'Vehicle rental and leasing',
        backgroundColor: '#E9E9E9',
        image: image18,
    },
    { name: 'Hotel', backgroundColor: '#FCEDE4', image: image19 },
    {
        name: 'Subway, tram, trolley bus',
        backgroundColor: '#E2EBF4',
        image: image20,
    },
    {
        name: 'Utilities buildings and infrastructure',
        backgroundColor: '#DAE4FA',
        image: image21,
    },
    { name: 'Food products', backgroundColor: '#EAF2E2', image: image22 },
    { name: 'Clothing', backgroundColor: '#FFF0C8', image: image23 },
    { name: 'Ceramic', backgroundColor: '#E7E9E8', image: image24 },
    { name: 'Other business services', backgroundColor: '#EBEBEB', image: image25 },
    {
        name: 'Activities of membership organizations',
        backgroundColor: '#FFFDE9',
        image: image26,
    },
    {
        name: 'Public administration and defence services',
        backgroundColor: '#E0F4FD',
        image: image27,
    },
]
